import { getCustomer } from "@/graphql/schemas/shared/utils/getCustomer"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { mapCustomerAddressInformation } from "../utils/customerAddressInformation"

export const queryCustomerAllAddresses = {
  async customerAllAddresses(parent, args, context, info) {
    const { customerId, customerKey, customerNumber } = args

    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.ADDRESSES,
      operation: Operations.READ,
    })

    const customer = await getCustomer({ id: customerId, key: customerKey, number: customerNumber })

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customer.customerNumber,
    })

    if (customer?.addresses?.lenght <= 0) return null

    const customerAddresses = customer.addresses

    // mapp all the addresses information with required and available fields
    const mappedAllAddresses = customerAddresses?.map((address) => {
      return mapCustomerAddressInformation(address, customer)
    })

    return { items: mappedAllAddresses, total: mappedAllAddresses?.length || 0 }
  },
}
